import React from "react";

import { CONTENT_TYPE } from "../../store/constants";
import FolderContentCases from "./FolderContentCases";
import TestContentCases from "./TestContentCases";
import VideoContentCases from "./VideoContentCases";
import { convertEpochToScheduleTime } from "@src/utils/liveService/util";
import PublishIcon from "@src/assets/publish.png";
import LiveClassRecordingCases from "./LiveClassRecordingCases";
import { addPreviewVideoContentAction } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "@src/lib/router";
import { funnelTrackAction } from "@src/components/Tabs/Overview/store/actions.js";
import { trackIDMap } from "../../../Overview/store/constants";
import styles from "../../styles/ContentList.module.scss";
import PracticeTestContent from "./PracticTestContent";
const ListItemDetails = ({ content, className, itemDetails }) => {
  // REDUX DISPATCH
  const dispatch = useDispatch();

  // NEXTJS ROUTER
  const router = useRouter();
  const state = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course
  );
  // FUNCTION TO HANDLE WHEN VIDEO ITEM CLICKED
  const handleVideoItemClicked = (e, videoItem) => {
    // STOPPING BUBBLING OF ACTION IF CONTENT TYPE IS VIDEO
    if (videoItem?.contentType === CONTENT_TYPE.VIDEO) {
      e?.stopPropagation();

      dispatch(
        funnelTrackAction({
          type: trackIDMap.contentView,
          isPurchased:
            state?.installments?.paidInstallmentSummary?.isPaymentComplete ===
              1 || state?.metaData?.isPurchased === 1,
          courseId: router?.query?.courseId,
          folderId: router?.query?.folderId || 0,
          contentId: videoItem.id,
          contentType: videoItem.contentType,
        })
      );
      // console.log("A______", videoItem);
      dispatch(addPreviewVideoContentAction(videoItem));
      router.push(`/${router?.query.courseId}/videopreview`);
    }
  };

  return (
    <div
      className={className}
      style={content?.contentType === CONTENT_TYPE.PRACTICE_TEST ? { maxWidth: "100%" ,width: "100%"} : {}}
      onClick={(e) => handleVideoItemClicked(e, content)}
    >
      <div className={styles.contentList__item__wrapper}>
        <p>{content?.name}</p>
        {(content?.isNewContent) ? (<span className={styles.contentList__item__newTag}>New</span>) : null}
      </div>

      {content?.contentType === CONTENT_TYPE.LIVE_CLASS && (
        <LiveClassRecordingCases content={content} />
      )}
      {content?.contentType === CONTENT_TYPE.FOLDER && (
        <FolderContentCases content={content} />
      )}
      {content?.contentType === CONTENT_TYPE.TEST && (
        <TestContentCases content={content} />
      )}
      <div
        style={{
          color: "#666666",
          marginTop: "0.5rem",
          fontWeight: "400",
          fontSize: "12px",
          lineHeight: "16px",
          display: "flex",
          alignItems: "center",
        }}
      >

       {content?.contentType === CONTENT_TYPE.PRACTICE_TEST && content?.URL && (
        <PracticeTestContent content={content} />
      )}
        {content?.contentTagImage ? (
          <img
            src={content?.contentTagImage}
            alt=""
            style={{ width: "30px", height: "20px", margin: "0 8px 0 0" }}
          />
        ) : null}
        {content?.contentTagText}
      </div>
      {content?.isScheduled == 0 && content?.resourceLiveDate ? (
        <div className={styles.contentList__item__content__publishedText}>
          <img
            src={PublishIcon.src}
            alt="publishIcon"
            width="12px"
            height="12px"
          />
          <span>
            <p>
              Published on:{" "}
              <span>
                {convertEpochToScheduleTime(content?.resourceLiveDate)}
              </span>
            </p>
          </span>
        </div>
      ) : (
        ""
      )}
      {content?.contentType === CONTENT_TYPE.VIDEO && (
        <VideoContentCases content={content} />
      )}
    </div>
  );
};

export default ListItemDetails;
